import { toaster } from '@/components/ui/toaster-instance';
import type { AdminProfileUpdate } from '@/types/admin-profile';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ADMIN_PROFILE_STATE_KEY, getAdminProfile, updateAdminProfile } from '../admin-profile-apis';

export const useAdminProfileQuery = (enabled: boolean) =>
  useQuery({
    queryKey: [ADMIN_PROFILE_STATE_KEY],
    queryFn: async () => (await getAdminProfile()).data,
    enabled,
    refetchOnWindowFocus: false,
    // The modal has its own "Try again" button, so skip the app-wide backoff that would hold the spinner for seconds.
    retry: false,
  });

/** Errors stay on the mutation so the modal can show them next to the form instead of a toast. */
export const useUpdateAdminProfileMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: AdminProfileUpdate) => (await updateAdminProfile(payload)).data,
    onSuccess: profile => {
      queryClient.setQueryData([ADMIN_PROFILE_STATE_KEY], profile);
      toaster.create({ title: 'Success', description: 'Profile saved', type: 'success' });
    },
  });
};
